export default __webpack_public_path__ + "static/media/50_desktop.1045461f.jpg";